export default "__VITE_ASSET__MZVSsAUs__"